import { useEffect, useState } from "react";
import { Link as Href } from "react-router-dom";
import { Link } from "react-scroll";
import Router from "../../const/router";
import Nav from "../Nav";
// Assets
import Logo from "../../assets/logo.svg";
import PersonPicture from "../../assets/3d-picture.png";
import Menu from "../../assets/menu.svg";
import "./index.scss";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="section-wrapper">
        <div className="row">
          <div
            onClick={() => setIsMenuOpen((prev) => !prev)}
            className="header-menu"
          >
            <img src={Menu} alt="menu" />
            {isMenuOpen && (
              <div className="header-menu-content">
                <Nav />
              </div>
            )}
          </div>
        </div>
        <div className="header-hero">
          <div className="header-hero-info">
            <h1>Hayk Ayvazyan</h1>
            <p>Software Engineer</p>
            <Link
              to="contact"
              activeClass="active-nav"
              spy={true}
              smooth={true}
              offset={20}
              duration={500}
            >
              Let's Talk
            </Link>
          </div>
          <div className="header-hero-picture">
            <img src={PersonPicture} alt="person" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
